<template>
  <div>
    <div class="contents">
      <div class="swings_view board_view">
        <div class="row" style="margin-bottom: 10px">
          <div class="col-lg-6">
            <h3 class="montserrat">
              {{ swingview.title }}
            </h3>
          </div>
          <div class="col-lg-6 text-end">
            <span class="date"
              ><i class="material-icons">date_range</i
              >{{ swingview.timezone_regdate | dateformat }}</span
            >
          </div>
        </div>
        <video
          controls
          :src="swingview.path + '/' + swingview.swingmovie"
          muted
          autoplay
        ></video>
        <div class="accordion" id="accordionExample">
          <div class="accordion-item">
            <b-collapse id="collapseOne" v-model="visible">
              <div class="accordion-body border-top-dgray">
                <div class="row">
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.club") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.club }}</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.ball_speed") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.ballspeed | comma }}km/h</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.backspin") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.backspin | comma }}rpm</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.carry") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.carry | comma }}m</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.club_speed") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.clubspeed | comma }}</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.ball_direction") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.balldirection | comma }}°</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.sidespin") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.sidespin | comma }}rpm</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.common.distance") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.distance | comma }}m</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.club_angle") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.clubnagel | comma }}°</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.launch_angle") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.launchangle | comma }}°</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.ball_pitch") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ change_balltype(swingview.balltype) }}</p>
                    </div>
                  </div>
                  <div class="col-lg-3 row border-bottom">
                    <div class="col-lg-6 bg-light align-items-center row">
                      <label>{{ $t("title.swing.tee_height") }}</label>
                    </div>
                    <div class="col-lg-6">
                      <p>{{ swingview.teeheight | comma }}mm</p>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
            <div class="row">
              <div class="col-lg-4 d-table m-auto">
                <h2 class="accordion-header" id="headingOne">
                  <b-button
                    class="accordion-button text-center"
                    :class="visible ? null : 'collapsed'"
                    :aria-expanded="visible ? 'true' : 'false'"
                    aria-controls="collapseOne"
                    variant="light"
                    @click="visible = !visible"
                  >
                    {{ $t("button.common.swing_info_view") }}
                  </b-button>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <p class="content">
          {{ swingview.content }}
        </p>
      </div>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="$router.push({ name: 'SwingList', query: searchData })"
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
      <div class="rebox">
        <b-form @submit="onSubmit">
          <div class="border-bottom comment">
            <h6 class="montserrat">
              {{ $t("title.swing.comment") }}({{ this.swingreplylistcnt }})
            </h6>
            <!--             <p>
              <strong class="text-orange">Comment{{ this.swingreplylistcnt }}</strong
              >
            </p> -->
            <input
              type="text"
              class="left"
              :placeholder="$t('text.swing.nickname_placeholder')"
              v-model="form.nickname"
            />
            <input
              type="text"
              class="form-control form-control-lg"
              :placeholder="$t('text.swing.comment_placeholder')"
              v-model="form.text"
            />
            <button class="near cursor border-0" type="submit">
              <i class="material-icons">near_me</i>
            </button>
          </div>
        </b-form>
        <div
          class="border-bottom repple"
          v-for="(item, index) in items"
          :key="index"
        >
          <img
            :src="VUE_APP_S3_BUCKET_URL + '/' + item.filename"
            v-if="item.filename"
            class="center-cropped"
          />
          <img
            :src="VUE_APP_S3_BUCKET_URL + '/playerfile/profile48x48.png'"
            class="center-cropped"
            v-else
          />

          <p class="name">
            <MemberInfo
              :nickname="item.nickname"
              :playerno="item.playerno"
              :displayText="item.nickname"
            />

            <span
              ><i class="material-icons">schedule</i
              >{{ item.timezone_regdate | dateformat }}</span
            >
          </p>
          <p class="balloon">{{ item.text }}</p>
          <a class="del cursor" @click="delReply(item.replyno)"
            ><i class="material-icons">cancel</i></a
          >
        </div>
      </div>
    </div>
    <b-pagination-nav
      :link-gen="linkGen"
      :number-of-pages="pageTotal"
      v-model="pageno"
      use-router
      :aria-label="$t('text.common.pagination')"
      v-if="pageTotal > 1"
      first-class="prev"
      prev-class="prev"
      next-class="next"
      last-class="next"
      hide-ellipsis
      limit="10"
    >
      <template #first-text
        ><i class="material-icons">keyboard_double_arrow_left</i></template
      >
      <template #prev-text
        ><i class="material-icons">navigate_before</i></template
      >
      <template #next-text
        ><i class="material-icons">navigate_next</i></template
      >
      <template #last-text
        ><i class="material-icons">keyboard_double_arrow_right</i></template
      >
      <template #page="{ page, active }">
        <a class="page-link" v-if="active">{{ page }}</a>
        <a class="page-link" v-else>{{ page }}</a>
      </template>
    </b-pagination-nav>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/swing";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "SwingView",

  data() {
    return {
      form: {
        text: "",
        nickname: "",
      },
      visible: false,
      swingno: this.$route.params.id || "",
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$store.state.searchData.startdate ||
          this.$dayjs().add(-1, "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate ||
          this.$store.state.searchData.enddate ||
          this.$dayjs().format("YYYY-MM-DD"),
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      swingview: [],
      items: [],
      swingreplylistcnt: 0,
      token: sessionStorage.getItem("token") || false,
      VUE_APP_S3_BUCKET_URL: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  watch: {
    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", val);
      },
      deep: true,
    },
  },
  mixins: [myMixin],
  created() {
    this.getView();
    this.getSwingreplyList();
  },
  methods: {
    getSwingreplyList() {
      ax.getSwingreplyList(this.swingno, this.pageno, (flag, data) => {
        if (flag) {
          if (data.swingreplylistcnt <= 0) {
            this.dataYn = false;
          } else {
            this.dataYn = true;
          }
          this.totalCnt = data.swingreplylistcnt;
          this.pageTotal = Math.ceil(data.swingreplylistcnt / this.rows);
          this.items = data.swingreplylist;
          this.swingreplylistcnt = data.swingreplylistcnt;
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          this.items = [];
        }
      });
    },
    delReply(replayno) {
      if (confirm(this.$i18n.t("alert.common.want_to_delete"))) {
        ax.setSwingreplyDrop(this.swingno, replayno, (flag, data) => {
          if (flag) {
            if (this.pageno > 1) this.$router.push({ query: { page: 1 } });
            else this.getSwingreplyList();
          } else {
            alert(data);
          }
        });
      }
    },
    onSubmit(event) {
      event.preventDefault();
      if (!this.token) {
        return false;
      }
      // todo : nickname 구할 곳이 없음
      ax.setSwingreplyWrite(
        this.swingno,
        this.form.nickname,
        this.form.text,
        (flag, data) => {
          if (flag) {
            this.form.text = "";
            this.form.nickname = "";
            this.getSwingreplyList();
          } else {
            alert(data);
          }
        }
      );
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    getView() {
      ax.getView(this.swingno, (flag, data) => {
        if (flag) {
          this.swingview = data.swingview;
        } else {
          alert(data);
        }
      });
    },
  },
};
</script>
